import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { first, timeout } from "rxjs/operators";
import { removeInitScreen } from "src/app/_helpers/appLoading";
import { Utils } from "src/app/_helpers/utils";
import { AuthenticationService, UserService } from "src/app/_services";
import { LoaderService } from "src/app/_services/loader.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { TranslateConfigService } from "src/app/_services/translate-config.service";
import { AuthService } from "./auth.service";
import { NavController } from "@ionic/angular";
import { customValidators } from "src/app/_helpers/customValidators";
import { Module } from "module";
import { AppModule } from "src/app/_helpers/module";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.page.html",
  styleUrls: ["./auth.page.scss", "./../../_styles/ion-grid-box.scss"],
})
export class AuthPage implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  subdomain: string;
  isSubdomain: boolean;
  validationError = false;
  unautorized = false;
  errorMessage: string = "";
  passwordEye = false;
  saveUserData: boolean = false;
  languageList = ["pl", "en"];
  currentLang: string;

  public localStorage: WindowLocalStorage;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    public menu: MenuController,
    public userServ: UserService,
    private loaderService: LoaderService,
    private ngZone: NgZone,
    public translateServ: TranslateService,
    private translateConfigService: TranslateConfigService,
    private p: ThisPlatform,
    public navController: NavController
  ) {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(["/"]);
    }
    this.menu.enable(false);
  }

  ngOnInit() {
    this.currentLang = this.translateServ.getBrowserLang();

    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

    this.subdomain = Utils.GetSubdomain(window.location.host);
    this.isSubdomain = this.subdomain ? true : false;

    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, customValidators.notWhiteSpacesPattern],
      ],
      password: ['', [Validators.required]],
      appname: [
        this.subdomain,
        [Validators.required, Validators.maxLength(10)],
      ],
      rememberMe: [true],
    });

    this.onGetUserDataFromLocalStorage();

    removeInitScreen();
  }

  changeLanguage(lang) {
    this.translateConfigService.setLanguage(lang);
    this.currentLang = lang;
  }

  ionViewWillEnter() {
    if (this.authenticationService.currentUserValue) {
      this.menu.enable(true);
    } else {
      this.menu.enable(false);
    }

    this.loading = false;
  }

  ngOnDestroy() {
    this.menu.enable(true);
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.validationError = true;
      return;
    }
    this.loading = true;
    this.authenticationService
      .login(
        this.f.email.value,
        this.f.password.value,
        this.f.appname.value.toUpperCase()
      )
      .pipe(first(), timeout(30000))
      .subscribe({
        next: (data) => {
          this.menu.enable(true);
          this.userServ.getPermision();
          this.authService.onSaveLastUSerInLocalStorage(this.loginForm);
          this.authService.getUserDataFromLocalStorage();
          let redirectAfterLogin = '/app/home';
          if (this.userServ.userStorage.firstRun == true) {
            redirectAfterLogin = '/app/first-run';
          }

          this.navController.navigateRoot(redirectAfterLogin);
        },
        error: (error) => {
          this.errorMessage = this.loginErrorMessage(error.error.code);
          this.unautorized = true;
          this.loading = false;
        },
      });

    // Jeżeli null to wyloguj
  }

  onGetUserDataFromLocalStorage() {
    if (localStorage.getItem("lastUser")) {
      const loginData = JSON.parse(localStorage.getItem("lastUser"));

      this.loginForm.patchValue({
        email: loginData[0],
        appname: loginData[1],
      });

    }
  }

  onPageDidLeave() {
    // enable the left menu when leaving the login page
    //this.menu.enable(true);
  }

  loginErrorMessage(code: number) {
    switch (code) {
      case 1:
        return "AUTH.ERROR.CREDENTIALS";
      case 2:
        return "AUTH.ERROR.NO_COMPANY";
      case 3:
        return "AUTH.ERROR.NOT_ACTIVATED";
      case 4:
        return "AUTH.ERROR.DEACTIVATED";
    }
  }

  passwordEyeAction() {
    this.passwordEye = !this.passwordEye;
  }
}
